"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _index = _interopRequireDefault(require("./index"));

var _styles = require("../styles");

var LightTooltip = (0, _styles.withStyles)(function (theme) {
  return {
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
      boxShadow: theme.shadows[3],
      fontSize: theme.typography.caption.fontSize,
      padding: theme.spacing(1)
    },
    arrow: {
      boxShadow: theme.shadows[3],
      color: theme.palette.common.white
    }
  };
})(_index["default"]);
var _default = LightTooltip;
exports["default"] = _default;